/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Caption_Settings_TabInputs */

const en_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption Settings`)
};

const fr_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres des sous-titres`)
};

const de_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteleinstellungen`)
};

const it_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni dei sottotitoli`)
};

const ru_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки субтитров`)
};

const es_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de subtítulos`)
};

const zh_cn2_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕设置`)
};

const ja_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕設定`)
};

const hi_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन सेटिंग्स`)
};

const pt_pt2_live_caption_caption_settings_tab = /** @type {(inputs: Live_Caption_Caption_Settings_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de legenda`)
};

/**
* | output |
* | --- |
* | "Caption Settings" |
*
* @param {Live_Caption_Caption_Settings_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_caption_settings_tab = /** @type {((inputs?: Live_Caption_Caption_Settings_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Caption_Settings_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_caption_settings_tab(inputs)
	if (locale === "de") return de_live_caption_caption_settings_tab(inputs)
	if (locale === "it") return it_live_caption_caption_settings_tab(inputs)
	if (locale === "ru") return ru_live_caption_caption_settings_tab(inputs)
	if (locale === "es") return es_live_caption_caption_settings_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_caption_settings_tab(inputs)
	if (locale === "ja") return ja_live_caption_caption_settings_tab(inputs)
	if (locale === "hi") return hi_live_caption_caption_settings_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_caption_settings_tab(inputs)
	return en_live_caption_caption_settings_tab(inputs)
});